module.exports = __webpack_public_path__ + "img/ban_16.cb007d02.png";